import { API_VERSION } from "@/config/global_data";
import { requestGet, requestDelete, requestPost, requestPut } from "./axios";

// context declaration
const commonContext = `/adminapi/${API_VERSION}`;
const apiContext = `/api/${API_VERSION}`;

// request methods
const common = {
  // 获取枚举
  enums: () =>
    requestGet(
      commonContext +
        "/common/enum/params?key=gender,problem_type,change_type,manage_rate,machine_every_time,machine_get_time,platform_trx_account,invite_reward_one_rate,invite_reward_two_rate,invite_reward_three_rate,invite_reward_one_platform,invite_reward_two_platform,invite_reward_three_platform"
    ),
  // 上传
  upload: (params) => requestPost(apiContext + "/file/images", params),
};

const auth = {
  //获取onece
  nonce: (params) => requestPost(apiContext + "/wallet-auth/challenge", params),
  //nonce登录
  noncelogin: (params) =>
    requestPost(apiContext + "/wallet-auth/verify", params),
  // 登录
  login: (params) => requestPost(apiContext + "/site/login", params),
  // 注册
  register: (params) => requestPost(apiContext + "/site/register", params),
  // 验证验证码
  verifyCode: (params) => requestPost(apiContext + "/sms/verify", params),
  // 设置交易密码
  assetsPassword: (params) =>
    requestPost(apiContext + "/member/trade-password", params),
  // 是否设置交易密码
  setAssetsPassword: (params) =>
    requestGet(apiContext + "/member/is-set-trade-password", params),
  // 退出
  logout: (params) => requestPost(apiContext + "/site/logout", params),
  // 重置密码
  upPwd: (params) => requestPost(apiContext + "/member/reset-password", params),
  // 获取国家代码
  countryCode: (params) =>
    requestGet(apiContext + "/country-code/index", params),
  // 获取验证码
  verificationCode: (params) => requestPost(apiContext + "/sms/send", params),
};

const home = {
  // 首页
  index: (params) => requestGet(apiContext + "/member/home", params),
  // 详情
  banner: (params) => requestGet(apiContext + "/member/banner", params),
  // 汇率
  rate: (params) => requestGet(apiContext + "/info/rate", params),
  // 新首页
  homeIndex: (params) => requestGet(apiContext + "/index/index", params),
  // 所有币种带涨跌幅度
  coinIndex: (params) => requestGet(apiContext + "/coin/index", params),
  // 收藏币种
  coinLike: (params) => requestPost(apiContext + "/coin/like", params),
  coindislike: (params) => requestDelete(apiContext + "/coin/dislike", params),
  // PC底部详情
  homeFooter: (params) => requestGet(apiContext + "/index/footer", params),
  //更新客服信息
  service: () => requestGet(apiContext + "/member/customer-service-reminder"),
  //活动
  promotion: () => requestGet(apiContext + "/promotion/latest"),
  //vip信息
  vipInfo: () => requestGet(apiContext + "/member/user"),
};

const asset = {
  // 资产信息
  index: (params) => requestGet(apiContext + "/member/index", params),
  // 资产详情
  feeLog: (params) => requestGet(apiContext + "/member/fee-log", params),
  // 获取余额
  balance: (params) => requestGet(apiContext + "/member/balance", params),
  // 提现
  withdraw: (params) => requestPost(apiContext + "/withdraw/withdraw", params),
  // 提现历史
  withdrawHistory: (params) =>
    requestGet(apiContext + "/withdraw/flow", params),
  // 签名
  withdrawSign: (params) =>
    requestPost(apiContext + "/withdrawal-agreement/create", params),
  // 充值
  recharge: (params) => requestPost(apiContext + "/member/recharge", params),
  // 充值支持的币种
  rechargeType: (params) =>
    requestGet(apiContext + "/recharge/currency", params),
  // 充值二维码
  rechargeCode: (params) => requestGet(apiContext + "/recharge/pre", params),
  // 充值福利
  rechargeGift: (params) => requestGet(apiContext + "/recharge/flows", params),
  // 福利打码量
  rechargeDamaliang: (params) =>
    requestGet(apiContext + "/recharge/damaliang", params),
  // 参与充值福利
  participateGift: (params) =>
    requestPost(apiContext + "/recharge/get-gift", params),
  // 手动充值提交
  manualRecharge: (params) =>
    requestPost(apiContext + "/recharge/recharge", params),
  // 充值历史
  rechargeHistory: (params) =>
    requestGet(apiContext + "/recharge/flows", params),
  // 获取提现规则
  withdrawRule: (params) =>
    requestGet(apiContext + "/member/get-withdraw-rule", params),
  // 获取提现支持的币种和网络
  withdrawalCoin: (params) =>
    requestGet(apiContext + "/withdrawal-coin/index", params),
  // 获取可提现金额
  withdrawMax: (params) =>
    requestGet(apiContext + "/member/get-withdraw-max", params),
  // 获取充值地址
  rechargePre: (params) =>
    requestGet(apiContext + "/recharge-coin/list", params),
  // 获取充值规则
  rechargeRule: (params) =>
    requestGet(apiContext + "/member/recharge-rule", params),
  // 收益划转
  transfer: (params) => requestPost(apiContext + "/member/transfer", params),
  // 提现手续费
  serviceCharge: (params) => requestGet(apiContext + "/withdraw/fee", params),
  // 汇率
  exchangeRate: (params) =>
    requestGet(apiContext + "/exchange-rate/rate", params),
  // 法币
  getFiatCurrency: (params) => requestGet(apiContext + "/fabi/index", params),
  //法币趋势图
  fiatList: (params) =>
    requestGet(apiContext + "/exchange-rate/currency", params),
  // 法币福利
  fiatGift: (params) => requestGet(apiContext + "/fabi/recharge-order", params),
  // 获取通道
  getGate: (params) => requestGet(apiContext + "/gate/index", params),
  // 创建法币充值订单
  fiatCurrencyRecharge: (params) =>
    requestPost(apiContext + "/fabi/recharge", params),
  // 创建法币出售订单
  fiatCurrencySell: (params) =>
    requestPost(apiContext + "/fabi/withdrawal", params),
  // 法币购买历史订单
  fiatCurrencyBuyHistory: (params) =>
    requestGet(apiContext + "/fabi/recharge-order", params),
  // 法币提现历史订单
  fiatCurrencySellHistory: (params) =>
    requestGet(apiContext + "/fabi/withdrawal-order", params),
  // 法币订单详情
  fiatCurrencyInfo: (params) =>
    requestGet(apiContext + "/fabi/order-detail", params),
  // 代收代付订单查询
  collectionPaymentOrder: (params) =>
    requestGet(apiContext + "/daishou/index", params),
  // 代收代付订单修改
  collectionPaymentOrderRevise: (params, id) =>
    requestPut(apiContext + "/daishou/update?id=" + id, params),
  // 钱包查询
  getwallet: (params) => requestGet(apiContext + "/wallet/new-index", params),
};

const mine = {
  // 消息列表
  noticeIndex: (params) => requestGet(apiContext + "/notice/index", params),
  // 消息详情、消息已读
  noticeGupdate: (params) => requestGet(apiContext + "/notice/gupdate", params),
  // 跑马灯列表
  messageIndex: (params) => requestGet(apiContext + "/marquee/index", params),
  // 反馈提交
  problem: (params) => requestPost(apiContext + "/member/problem", params),
  // 地址列表
  addressIndex: (params) => requestGet(apiContext + "/address/index", params),
  // 地址渲染
  addressDetail: (params) =>
    requestGet(apiContext + "/address/gupdate", params),
  // 地址新增
  addressCreate: (params) =>
    requestPost(apiContext + "/address/create", params),
  // 地址更新
  addressUpdate: (params, id) =>
    requestPut(apiContext + "/address/update?id=" + id, params),
  // 地址删除
  addressDelete: (params) =>
    requestDelete(apiContext + "/address/delete", params),
  // 团队列表
  teamIndex: (params) => requestGet(apiContext + "/member/team-list", params),
  // 团队奖励列表
  teamBonusList: (params) =>
    requestGet(apiContext + "/member/team-profit-list", params),
  // 团队奖励详情
  teamBonusDetail: (params) =>
    requestGet(apiContext + "/member/team-profit-detail", params),
  // 获取钱包类型
  getWalletType: (params) =>
    requestGet(apiContext + "/wallet-type/index", params),
  // 修改登录密码
  modifyLoginPassword: (params) =>
    requestPost(apiContext + "/member/modify-password", params),
  // 修改资产密码
  modifyAssetPassword: (params) =>
    requestPost(apiContext + "/member/modify-password", params),
  // 邀请好礼首页
  invite: (params) => requestGet(apiContext + "/invite-level/index", params),
  // 邀请规则
  inviteRule: (params) =>
    requestGet(apiContext + "/invite-level/rules", params),
  // 邀请收入
  inviteLevel: (params) =>
    requestGet(apiContext + "/invite-level/static", params),
  // 邀请状态
  inviteState: (params) =>
    requestGet(apiContext + "/invite-level/level-one-kyc", params),
  // 邀请的下级关系
  inviteFriend: (params) =>
    requestGet(apiContext + "/invite-level/child", params),
  // 提交身份信息
  identityVerification: (params) =>
    requestPost(apiContext + "/member/kyc", params),
  // 获取验证身份信息
  identityVerificationInfo: (params) =>
    requestGet(apiContext + "/member/kyc-info", params),
  // 获取学院分类
  academyType: (params) =>
    requestGet(apiContext + "/tutorial-type/index", params),
  // 获取学院信息
  academyInfo: (params) => requestGet(apiContext + "/tutorial/index", params),
  // 获取教程详情
  tutorialInfo: (params) => requestGet(apiContext + "/tutorial/view", params),
  // 获取法币银行
  getBank: (params) => requestGet(apiContext + "/fabi/bank", params),
  // 获取收款账户
  receivingAccount: (params) =>
    requestGet(apiContext + "/withdraw-account/index", params),
  // 添加收款账户
  addReceivingAccount: (params) =>
    requestPost(apiContext + "/withdraw-account/create", params),
  // 更新收款账户
  putReceivingAccount: (params) =>
    requestGet(apiContext + "/withdraw-account/update", params),
  // 删除收款账户
  delReceivingAccount: (params) =>
    requestDelete(apiContext + "/withdraw-account/delete", params),
  //通知
  getMessages: (params) =>
    requestGet(apiContext + "/member-alert/index", params),
  //通知原点
  hasMessage: () => requestGet(apiContext + "/member-alert/index"),
  // 获取协议详情
  protocolInfo: (params) =>
    requestGet(apiContext + "/index/footer-detail", params),
};

const product = {
  // 产品列表
  productList: (params) =>
    requestGet(apiContext + "/finance/product/index", params),
  // 产品详情
  productInfo: (params) =>
    requestGet(apiContext + "/financial-product/detail", params),
  // 购买产品
  productBuy: (params) =>
    requestPost(apiContext + "/finance/product/buy", params),
  // 购买历史
  productHistory: (params) =>
    requestGet(apiContext + "/finance/order/index", params),
  // 赎回
  redeem: (params) =>
    requestPost(apiContext + "/finance/order/redeemed", params),
  //热门产品
  hotList: () => requestGet(apiContext + "/finance/product/hot"),
  //理财轮播
  bannerListL: () => requestGet(apiContext + "/finance/banner/index"),
  //新理财
  products: () => requestGet(apiContext + "/vip-finance/config"),
  //新理财订单
  productOrders: (params) =>
    requestGet(apiContext + "/vip-finance/orders", params),
  //新理财详情
  productInfo: (params) =>
    requestGet(apiContext + "/vip-finance/preview", params),
  // 新理财下单
  buyProduct: (params) => requestPost(apiContext + "/vip-finance/buy", params),
  //新理财流水
  productFlow: (params) =>
    requestGet(apiContext + "/vip-finance/profit-logs", params),
  //新理财规则
  productRule: () => requestGet(apiContext + "/vip-finance/rules"),
  //新理财vip规则
  vipRule: () => requestGet(apiContext + "/vip-finance/level-rules"),
  //新VIP等级
  vipLv: () => requestGet(apiContext + "/vip-finance/web3-stats"),
};

const welfare = {
  // 福利任务
  welfareTask: (params) => requestGet(apiContext + "/task/index", params),
  // 福利领取
  welfareTaskReceive: (params) =>
    requestPost(apiContext + "/task/receive-bonus", params),
  // 福利领取记录
  welfareTaskRecord: (params) =>
    requestGet(apiContext + "/task/member-task", params),
};

const picking = {
  // 获取期号信息
  getPickine: (params) =>
    requestGet(apiContext + "/futures-battle/index", params),
  create: (params) => requestPost(apiContext + "/order/create", params),
  // 指数竞猜获胜榜
  countRank: (params) =>
    requestPost(apiContext + "/futures-battle/win-count-rank", params),
  // 指数竞猜盈利
  profitRank: (params) =>
    requestPost(apiContext + "/futures-battle/profit-rank", params),
};
const fundTransfer = {
  // 获取闪兑货币
  getCurrency: (params) =>
    requestGet(apiContext + "/info/flash-exchange", params),
  // 获取闪兑历史
  getExchangeHistory: (params) =>
    requestGet(apiContext + "/wallet/flash-exchange-flow", params),
  // 闪兑
  exchange: (params) => requestPost(apiContext + "/wallet/exchange", params),
};
const wallet = {
  // 获取账户资金
  getAccountFunds: (params) => requestGet(apiContext + "/wallet/index", params),
  // 获取账户资金
  getBalance: (params) => requestGet(apiContext + "/wallet/balance", params),
  // 获取币种流水
  getBillFlow: (params) => requestGet(apiContext + "/wallet/flow", params),
  // 获取划转信息
  getTransform: (params) =>
    requestGet(apiContext + "/wallet/transfer-rule", params),
  // 提交划转
  transform: (params) => requestPost(apiContext + "/wallet/transfer", params),
};
const quotation = {
  // 获取划转信息
  postFutures: (params) =>
    requestPost(apiContext + "/futures/create-order", params),
  // 合约订单
  orderform: (params) => requestGet(apiContext + "/futures/order", params),
  // 一键平仓
  closeBack: (params) => requestPost(apiContext + "/futures/close-all", params),
  // 平仓
  futuresclose: (params) => requestPost(apiContext + "/futures/close", params),
  // 反平仓
  reverseclose: (params) =>
    requestPost(apiContext + "/futures/reverse-close", params),
  // 取消
  futurescancel: (params) =>
    requestPost(apiContext + "/futures/cancel", params),
  // 一键撤销
  sendBack: (params) => requestPost(apiContext + "/futures/cancel-all", params),
  // 止盈止损修改
  createorder: (id, params) =>
    requestPut(apiContext + "/futures/update-order?id=" + id, params),
  // 合约头部 futures/global
  futuresglobal: (params) => requestGet(apiContext + "/futures/global", params),
  // 交易历史
  getQuotationHistory: (params) =>
    requestGet(apiContext + "/futures/order", params),
  // K线图/futures/candlesticks
  candlesticks: (params) =>
    requestGet(apiContext + "/futures/candlesticks", params),
  // 市场深度信息 /futures/order-book
  tickers: (params) => requestGet(apiContext + "/futures/tickers", params),
  // 加仓 /futures/add-order
  gallons: (params) => requestPost(apiContext + "/futures/add-order", params),
  //外汇详情
  forex: (params) => requestGet(apiContext + "/forex/candlesticks", params),
  //外汇列表
  forexList: (params) => requestGet(apiContext + "/forex/index", params),
  //外汇头部的信息
  forexHeader: (params) => requestGet(apiContext + "/forex/global", params),
  //创建外汇订单
  createForexOrder: (params) =>
    requestPost(apiContext + "/forex/create-order", params),
  //持仓量
  getForexOrder: (params) => requestGet(apiContext + "/forex/order", params),
  //外汇
  sellForex: (params) => requestPost(apiContext + "/forex/close", params),
  //修改价位
  editPrice: (params, id) =>
    requestPut(apiContext + "/forex/update-order?id=" + id, params),
  //取消订单
  cancelForex: (params) => requestPost(apiContext + "/forex/cancel", params),
  //币币交易
  currencyBuy: (params) =>
    requestPost(apiContext + "/coin-to-coin/exchange", params),
  //取消委托交易
  cancelCurrency: (params) =>
    requestDelete(apiContext + "/coin-to-coin/cancel", params),
  //币币交易记录
  currencyHistory: (params) =>
    requestGet(apiContext + "/coin-to-coin/orders", params),
  //外汇期货交割合约首页
  forexOptionIndex: (params) =>
    requestGet(apiContext + "/forex-option/index", params),
  //外汇期货交割合约流水
  forexOptionFlow: (params) =>
    requestGet(apiContext + "/forex-option/flow", params),
  // 外汇期货交割合约规则
  forexOptionRuler: (params) =>
    requestGet(apiContext + "/forex-option/rule", params),
  // 外汇期货交割合约购买
  forexOptionBuy: (params) =>
    requestPost(apiContext + "/forex-option/order", params),
};

//现货合约
const contract = {
  //现货头部
  contractGlobal: (params) =>
    requestGet(apiContext + "/contract1x/global", params),
  //现货购买
  createOrder: (params) =>
    requestPost(apiContext + "/contract1x/create-order", params),
  //现货加仓
  addOrder: (params) =>
    requestPost(apiContext + "/contract1x/add-order", params),
  //现货平仓
  close: (params) => requestPost(apiContext + "/contract1x/close", params),
  //现货市场深度
  tickers: (params) => requestGet(apiContext + "/contract1x/tickers", params),
  //修改止盈、止损
  changePrice: (params, id) =>
    requestPut(apiContext + "/contract1x/update-order?id=" + id, params),
  //现货订单列表
  contractOrderList: (params) =>
    requestGet(apiContext + "/contract1x/order", params),
  //现货取消订单
  contractOrder: (params) =>
    requestPost(apiContext + "/contract1x/cancel", params),
};

const options = {
  // 期权首页
  getOptions: (params) => requestGet(apiContext + "/option/index", params),
  // 期权币种
  getOptionCoin: (params) => requestGet(apiContext + "/option/coin", params),
  // 期权K线
  getKLine: (params) => requestGet(apiContext + "/option/candlesticks", params),
  // 期权流水
  getOptionsHistory: (params) =>
    requestGet(apiContext + "/option/flow", params),
  // 期权购买
  optionsBuy: (params) => requestPost(apiContext + "/option/order", params),
  // 期权规则
  getOptionsRule: (params) => requestGet(apiContext + "/option/rule", params),
  //期权订单详情
  getOptionDetail: (params) =>
    requestGet(apiContext + "/option/detail", params),
};

const football = {
  // 赛事列表
  getFootball: (params) => requestGet(apiContext + "/sport/index", params),
  // 赛事列表刷新
  getFootballRefresh: (params) =>
    requestGet(apiContext + "/sport/event", params),
  // 赛事详情
  getFootballInfo: (params) => requestGet(apiContext + "/sport/detail", params),
  // 联赛列表
  getLeague: (params) => requestGet(apiContext + "/league/index", params),
  // 比赛下单
  footballBet: (params) =>
    requestPost(apiContext + "/sport-order/create", params),
  // 下注历史
  getFootballOrder: (params) =>
    requestGet(apiContext + "/sport-order/index", params),
  // 足球任务
  getFootballTask: (params) =>
    requestGet(apiContext + "/sport-task/index", params),
  // 领取足球任务奖励
  receiveFootballTask: (params) =>
    requestPost(apiContext + "/sport-task/receive", params),
  // 足球任务下单
  footballTaskBet: (params) =>
    requestPost(apiContext + "/sport-task/create", params),
  // 足球任务订单
  getFootballTaskOrder: (params) =>
    requestGet(apiContext + "/sport-task/order", params),
  // 下注历史
  getFootballSummary: (params) =>
    requestGet(apiContext + "/sport-order/summary", params),
};

const recruitment = {
  // 申请代理
  application: (params) => requestPost(apiContext + "/spread/apply", params),
  // 首页
  getRecruitmentIndex: (params) =>
    requestGet(apiContext + "/spread/index", params),
  // 首页分析
  getRecruitmentAnalyze: (params) =>
    requestGet(apiContext + "/spread/analyze", params),
  // 成员统计
  getMemberStatistics: (params) =>
    requestGet(apiContext + "/spread/child-statistics", params),
  // 成员列表
  getMemberList: (params) => requestGet(apiContext + "/spread/child", params),
  // 成员信息
  getMemberInfo: (params) =>
    requestGet(apiContext + "/spread/child-info", params),
  // 成员订单
  getMemberOrder: (params) =>
    requestGet(apiContext + "/spread/child-info-order", params),
  // 渠道列表
  getChannelList: (params) =>
    requestGet(apiContext + "/spread/channel-list", params),
  // 渠道详情
  getChannelInfo: (params) =>
    requestGet(apiContext + "/spread/channel-detail", params),
  // 创建渠道
  addChannel: (params) => requestPost(apiContext + "/spread/channel", params),
  // 启用禁用渠道
  enableDisableChannel: (params, id) =>
    requestPut(apiContext + "/spread/channel-toggle?id=" + id, params),
  // 财务报表
  getStatements: (params) =>
    requestGet(apiContext + "/spread/statistics", params),
  // VIP规则
  getVipRule: (params) => requestGet(apiContext + "/spread/vip-rule", params),
  // VIP规则列表
  getVipRuleList: (params) =>
    requestGet(apiContext + "/spread/vip-level", params),
  // 计算规则
  getCalculationRules: (params) =>
    requestGet(apiContext + "/spread/rule", params),
  // 计算规则列表
  getCalculationRulesList: (params) =>
    requestGet(apiContext + "/spread/level-rule", params),
  // 记录邀请码访问量
  recordAccess: (params) => requestGet(apiContext + "/spread/ip", params),
  // 分红
  getDividends: (params) => requestGet(apiContext + "/spread/log", params),
  // 分红月度详情
  getDividendsInfo: (params) =>
    requestGet(apiContext + "/spread/log-detail", params),
  // 订单
  getRecruitmentOrder: (params) =>
    requestGet(apiContext + "/spread/order", params),
  // 订单详情
  getRecruitmentOrderInfo: (params) =>
    requestGet(apiContext + "/spread/order-detail", params),
  // 返水记录
  getRebate: (params) => requestGet(apiContext + "/spread/rebate-log", params),
  // 返水记录详情
  getRebateInfo: (params) =>
    requestGet(apiContext + "/spread/rebate-log-detail", params),
};

const activity = {
  // 投资首页
  getInvestIndex: (params) =>
    requestGet(apiContext + "/investment-master/index", params),
  // 投资申请领取
  investApplication: (params) =>
    requestPost(apiContext + "/investment-master/join", params),
};

const lottery = {
  // 玩法
  getHowPlay: (params) => requestGet(apiContext + "/lhc-game/index", params),
  // 六合彩信息（号码和生肖相互转换）
  getInfo: (params) => requestGet(apiContext + "/lhc/info", params),
  // 玩法详情
  getPlayInfo: (params) =>
    requestGet(apiContext + "/lhc-gameplay/index", params),
  // 下注/添加到注单
  submitBet: (params) => requestPost(apiContext + "/lhc/order", params),
  // 注单列表
  betList: (params) => requestGet(apiContext + "/lhc/cart", params),
  // 注单删除
  betListDel: (params) =>
    requestDelete(apiContext + "/lhc/cart-delete", params),
  // 注单提交
  betSub: (params) => requestPost(apiContext + "/lhc/cart-to-order", params),
  // 订单列表
  orderList: (params) => requestGet(apiContext + "/lhc/flow", params),
  // 订单详情
  orderInfo: (params) => requestGet(apiContext + "/lhc/order-detail", params),
};
// 外汇永续合约
const forexContract = {
  // 新头部
  Fcontract: (params) =>
    requestGet(apiContext + "/forex-contract/global", params),
  // 创建订单
  createOrder: (params) =>
    requestPost(apiContext + "/forex-contract/create-order", params),
  // 获取订单
  getNewForexOrder: (params) =>
    requestGet(apiContext + "/forex-contract/order", params),
  // 修改订单
  changeNewForexOrder: (params, id) =>
    requestPut(apiContext + "/forex-contract/update-order?id=" + id, params),
  // 平仓
  newsellForex: (params) =>
    requestPost(apiContext + "/forex-contract/close", params),
  // 加仓
  addForex: (params) =>
    requestPost(apiContext + "/forex-contract/add-order", params),
  // 取消订单
  newcancelForex: (params) =>
    requestPost(apiContext + "/forex-contract/cancel", params),
};

export default {
  auth,
  common,
  home,
  asset,
  mine,
  product,
  welfare,
  picking,
  fundTransfer,
  wallet,
  quotation,
  contract,
  options,
  football,
  recruitment,
  activity,
  lottery,
  forexContract,
};



// WEBPACK FOOTER //
// ./src/api/index.js